import { notFound } from '@tanstack/react-router'

interface ActualVsBudgetEnvironment {
  VITE_ACTUAL_VS_BUDGET_ENABLED?: string
  VITE_ACTUAL_VS_BUDGET_PORTFOLIO_ENABLED?: string
}

export function isActualVsBudgetEnabled(
  environment: ActualVsBudgetEnvironment
) {
  return environment.VITE_ACTUAL_VS_BUDGET_ENABLED === 'true'
}

export function isActualVsBudgetPortfolioEnabled(
  environment: ActualVsBudgetEnvironment
) {
  return (
    isActualVsBudgetEnabled(environment) &&
    environment.VITE_ACTUAL_VS_BUDGET_PORTFOLIO_ENABLED === 'true'
  )
}

export function requireActualVsBudgetPortfolioAccess(
  _routeContext: unknown,
  environment: ActualVsBudgetEnvironment = import.meta.env
) {
  if (!isActualVsBudgetPortfolioEnabled(environment)) {
    throw notFound()
  }
}
